import m from "../../geodata/es2015/russiaCrimeaHigh";
window.am4geodata_russiaCrimeaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/russiaCrimeaHigh.js
// module id = null
// module chunks = 